@file:Suppress("unused")

package com.eladfinish.bible.contest.platform

import androidx.compose.runtime.Composable

expect val platformInfo: PlatformTarget

enum class PlatformTarget {
    ANDROID,
    IOS,
    WEB,
    DESKTOP,
}

val isAndroid = platformInfo == PlatformTarget.ANDROID
val isIos = platformInfo == PlatformTarget.IOS
val isWeb = platformInfo == PlatformTarget.WEB
val isDesktop = platformInfo == PlatformTarget.DESKTOP

/**
 * True when the primary pointing device is a mouse or trackpad rather than a finger. Screens use
 * it to show scrollbars, which a touch screen does not need. On the web it follows the device the
 * site is opened on, so a phone browser gets `false`.
 */
expect val hasMousePointer: Boolean

fun <T> platformSpecific(
    forAndroid: () -> T,
    forIos: () -> T,
    forWeb: () -> T = forAndroid,
    forDesktop: () -> T = forWeb,
): T =
    when (platformInfo) {
        PlatformTarget.ANDROID -> forAndroid()
        PlatformTarget.IOS -> forIos()
        PlatformTarget.WEB -> forWeb()
        PlatformTarget.DESKTOP -> forDesktop()
    }

@Composable
fun <T> composePlatformSpecific(
    forAndroid: @Composable () -> T,
    forIos: @Composable () -> T,
    forWeb: @Composable () -> T = forAndroid,
    forDesktop: @Composable () -> T = forWeb,
): T =
    when (platformInfo) {
        PlatformTarget.ANDROID -> forAndroid()
        PlatformTarget.IOS -> forIos()
        PlatformTarget.WEB -> forWeb()
        PlatformTarget.DESKTOP -> forDesktop()
    }

@Composable
fun OnlyForAndroid(
    content: @Composable () -> Unit,
) = when (platformInfo) {
    PlatformTarget.ANDROID -> content()
    PlatformTarget.IOS -> Unit
    PlatformTarget.WEB -> Unit
    PlatformTarget.DESKTOP -> Unit
}

@Composable
fun OnlyForIos(
    content: @Composable () -> Unit,
) =
    when (platformInfo) {
        PlatformTarget.ANDROID -> Unit
        PlatformTarget.IOS -> content()
        PlatformTarget.WEB -> Unit
        PlatformTarget.DESKTOP -> Unit
    }
